/*
 * File: DateInput.tsx
 * Author: Austin Robinson
 * Date Created: 2/06/2024
 * Copyright (c) DrivingDoc 2024
 */
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker, TimePickerProps } from '@mui/x-date-pickers/TimePicker';
import dayjs, { Dayjs } from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';

interface PropTypes extends TimePickerProps<Dayjs> {
  name: string;
  label: string;
}

export default function TimeInput({ name, label, ...props }: PropTypes) {
  const { control } = useFormContext();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => (
          <TimePicker
            label={label}
            timezone="system"
            slotProps={{
              textField: {
                variant: 'standard',
                fullWidth: true,
                InputLabelProps: { shrink: true },
                error: !!fieldState.error,
                helperText: fieldState.error?.message,
                onBlur: field.onBlur,
              },
            }}
            inputRef={field.ref}
            value={dayjs(field.value)}
            onChange={(newValue) => {
              const time = dayjs(newValue).toISOString();
              field.onChange(time);
            }}
            onError={(newError) => console.log(`Date Error: ${newError}`)}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
}
